<router-outlet></router-outlet>
<app-loader></app-loader>
<app-notification-toast></app-notification-toast>
<div *ngIf="appUpdate.updateAvailable$ | async" class="update-banner" role="status">
    <span>A new version of AdvERP is available.</span>
    <button type="button" class="btn btn-sm btn-light ms-3" (click)="appUpdate.reload()">Reload</button>
</div>
